var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#6FCF97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5866 0.666687H8.41329C3.55996 0.666687 0.666626 3.56002 0.666626 8.41335V19.5734C0.666626 24.44 3.55996 27.3334 8.41329 27.3334H19.5733C24.4266 27.3334 27.32 24.44 27.32 19.5867V8.41335C27.3333 3.56002 24.44 0.666687 19.5866 0.666687ZM20.3733 10.9334L12.8133 18.4934C12.6266 18.68 12.3733 18.7867 12.1066 18.7867C11.84 18.7867 11.5866 18.68 11.4 18.4934L7.62663 14.72C7.23996 14.3334 7.23996 13.6934 7.62663 13.3067C8.01329 12.92 8.65329 12.92 9.03996 13.3067L12.1066 16.3734L18.96 9.52002C19.3466 9.13335 19.9866 9.13335 20.3733 9.52002C20.76 9.90669 20.76 10.5334 20.3733 10.9334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1d1a2196d95c307371357c315e019486.svg";
export { ForwardRef as ReactComponent };